<template>
  <div :class="['header',(hidden&&!searchBarFixed)?'hidden':'', searchBarFixed?'isFixed':'']">
    <div class="headNav clearfix">
      <div class="head-left">
        <div class="user-name">
          <router-link to="/" style="color:#333">
            <img style="height:65px;margin-top:-8px" src="../assets/image/logo3.png" alt="车检速培在线教育" />
          </router-link>
        </div>
        <NavList />
      </div>
      <div class="head-right">
        <div class="head-right-left" v-if="$route.path!=='/search'">
          <el-input type="text" v-model="keywords" placeholder="请输入搜索关键词" class="head-search" />
          <i style="vertical-align:middle;cursor: pointer;" @click="toNext" class="el-icon-search"></i>
        </div>
        <div class="head-right-logo">
          <el-dropdown v-if="user.token" style="width:40px;height:40px;    margin-top: 15px;">
            <el-image style="width:40px;height:40px;border-radius:20px" :src="user.type!=2?user.avatar:user.company_logo" />

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="$router.push('/userMessage')">个人中心</el-dropdown-item>
              <el-dropdown-item @click.native="logExit">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <span
            v-if="user.token"
            @click="logExit"
            style="display:block; height: 32px;color:#409EFF;    cursor: pointer;line-height:32px;"
          >退出</span>-->
          <span v-else style="display:block; height: 72px;line-height:72px">
            <router-link to="/login">登录</router-link>/
            <router-link to="/register">注册</router-link>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavList from "./NavList";
import { mapState, mapActions } from "vuex";
export default {
  name: "commonHeader",
  components: { NavList },
  props: {
    hidden: Boolean,
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
  data() {
    return {
      keywords: "",
      searchBarFixed: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    ...mapActions({
      logOut: "user/logOut",
    }),
    toNext() {
      console.log(this.keywords.length);
      if (this.keywords.length == 0) {
        this.$message.error("请输入关键字");
        return false;
      }
      this.$router.push({ path: "/search", query: { name: this.keyWords } });
    },
    logExit() {
      this.logOut();
      this.$router.push("login");
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 30) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.cons {
  width: 1100px;
  margin: 0 auto;
}
.isFixed {
  position: fixed;
  background-color: #eee;
  border-bottom: solid 1px #eee;
  top: 0;
  z-index: 999;
  display: block;
}
.header {
  height: 72px;
  width: 100%;
  background-color: #f2f2f2;
  border-bottom: solid 1px rgba(255, 255, 255, 1);
  // box-shadow: 0px 3px 5px 0px rgba(195, 195, 195, 0.3);

  .head-left {
    float: left;
    margin-top: 10px;
    width: 1000px;
  }
  .user-name {
    font-size: 16px;
    font-weight: bold;
    line-height: 52px;
    height: 52px;
    float: left;
  }
  .nav-link {
    display: block;
    color: rgba(77, 85, 93, 1);
    text-decoration: none;
  }
  .nav-item {
    float: left;
    width: 104px;
    line-height: 72px;
    height: 72px;
    font-size: 16px;
    text-align: center;
  }
  .active {
    color: rgba(42, 130, 228, 1);
  }
}
.head-right {
  float: right;
  height: 72px;
  line-height: 72px;
  .head-search {
    width: 160px;

    border-radius: 12px;
    font-size: 12px;
  }
}
.el-icon-search {
  margin-left: 5px;
  margin-right: 50px;
  font-size: 18px;
}
.head-right-left {
  float: left;
}
.hidden {
  display: none;
}
.head-right-logo {
  float: right;

  height: 72px;
  border-radius: 16px;
  vertical-align: middle;
}
.headNav{
  width: 1380px;
  margin: 0 auto;
}
</style>
